import React from "react";
import { Box, InputAdornment, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithEndAdornText = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p:3 }}>
      <PreviewAndEditor
        title={"textfield with End text adornment"}
        language={"js"}
        value={
          "<TextField\n" +
          '          label="Outlined"\n' +
          '          placeholder={"search"}\n' +
          "          InputProps={{\n" +
          "            startAdornment: (\n" +
          '              <InputAdornment position="start">\n' +
          "                https://\n" +
          "              </InputAdornment>\n" +
          "            ),\n" +
          "          }}\n" +
          "        />\n" +
          "        <TextField\n" +
          '          label="Filled"\n' +
          '          variant="filled"\n' +
          '          placeholder={"search"}\n' +
          "          InputProps={{\n" +
          "            startAdornment: (\n" +
          '              <InputAdornment position="start">https://</InputAdornment>\n' +
          "            ),\n" +
          "          }}\n" +
          "        />\n" +
          "        <TextField\n" +
          '          label="Standard"\n' +
          '          variant="standard"\n' +
          '          placeholder={"search"}\n' +
          "          InputProps={{\n" +
          "            startAdornment: (\n" +
          '              <InputAdornment position="start">https://</InputAdornment>\n' +
          "            ),\n" +
          "          }}\n" +
          "        />"
        }
      >
        <TextField
          label="Outlined"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                https://
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Filled"
          variant="filled"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                https://
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Standard"
          variant="standard"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                https://
              </InputAdornment>
            ),
          }}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldWithEndAdornText;
